import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import OpenInNewOutlinedIcon from '@material-ui/icons/OpenInNewOutlined';

import RequestAppliedOffersSkeleton from '../skeleton/request-applied-offers-skeleton';
import { checkTokenExpirationMiddleware } from '../../../../middlewares/users-auth.middleware';
import { renderAttachment } from '../../../../helpers/attachment-helper';

const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
    wideTd: {
        minWidth: `125px`,
        maxWidth: `300px`
    }
});

const HotelAppliedOffers = ({ reloadOffers, reservationReqId }) => {
    const [hotelOffers, setHotelOffers] = useState(null);
    const [user] = useState(checkTokenExpirationMiddleware());
    const [loading, setLoading] = useState(true);
    const [, setError] = useState(null);

    let headers = {
        "Authorization": `Bearer ${user.Token}`
    };
    useEffect(() => {
        setLoading(true);
        axios.get(`/api/hoteloffer?reservationReqId=${reservationReqId}`, { headers: headers })
            .then(res => {
                setHotelOffers(res.data);
                setTimeout(() => setLoading(false), 750);
            })
            .catch(err => { setError({ error: "Error Loading page" }); });
    }, [reloadOffers]);

    return (
        loading ?
            <RequestAppliedOffersSkeleton />
            :
            hotelOffers.length > 0 ?
                <TableContainer>
                    <Table aria-label="collapsible table">
                        <TableHead>
                            <TableRow>
                                <TableCell />
                                <TableCell>Offer Headline</TableCell>
                                <TableCell>More Details</TableCell>
                                <TableCell>Hotel Name</TableCell>
                                <TableCell>Create Date</TableCell>
                                <TableCell>Created By</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                hotelOffers ?
                                    hotelOffers.map((hotelOffer, index) => (
                                        <Row key={index} row={hotelOffer} />
                                    )) :
                                    null
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                :
                <>
                    You haven't applied any offers for this request.
                </>
    );
}

const Row = ({ row }) => {
    const [open, setOpen] = React.useState(false);
    const classes = useRowStyles();
    return (
        <React.Fragment>
            <TableRow className={classes.root}>
                <TableCell>
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell className={classes.wideTd}>{row.offerHeadline}</TableCell>
                <TableCell>
                    <Link to={`/offer/hotel/${row.id}`}><OpenInNewOutlinedIcon /></Link>
                </TableCell>
                <TableCell component="th" scope="row" className={classes.wideTd}>
                    {row.hotelName}
                </TableCell>
                <TableCell className={classes.wideTd}>{row.createDate.replace('T', ' ').substring(0, 16)}</TableCell>
                <TableCell className={classes.wideTd}>{row.createdBy}</TableCell>
            </TableRow>
            {
                row.reservationSupplierHotelAccommodationResources.length > 0 ?
                    <TableRow>
                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
                            <Collapse in={open} timeout="auto" unmountOnExit>
                                <Box margin={1}>
                                    <Typography variant="h6" gutterBottom component="div">
                                        Acommodation Rooms
                                    </Typography>
                                    <Table size="small" aria-label="Hotels">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Check In</TableCell>
                                                <TableCell>Check Out</TableCell>
                                                <TableCell>Room Category</TableCell>
                                                <TableCell>Room Type</TableCell>
                                                <TableCell>Meal Plan</TableCell>
                                                <TableCell>No. Of Rooms</TableCell>
                                                <TableCell>Room Price</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {row.reservationSupplierHotelAccommodationResources[0]
                                                .reservationSupplierHotelAccommodationRoomResources.map((RoomRow, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell component="th" scope="row">
                                                            {RoomRow.checkIn.replace('T', ' ').substring(0, 16)}
                                                        </TableCell>
                                                        <TableCell>{RoomRow.checkOut.replace('T', ' ').substring(0, 16)}</TableCell>
                                                        <TableCell>{RoomRow.roomCategory}</TableCell>
                                                        <TableCell>{RoomRow.roomType}</TableCell>
                                                        <TableCell>{RoomRow.mealPlan}</TableCell>
                                                        <TableCell>{RoomRow.noofRooms}</TableCell>
                                                        <TableCell>{RoomRow.roomPrice}</TableCell>
                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </Box>
                            </Collapse>
                        </TableCell>
                    </TableRow>
                    : null
            }
            {
                row.reservationSupplierHotelMeetingResources.length > 0 ?
                    <TableRow>
                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={19}>
                            <Collapse in={open} timeout="auto" unmountOnExit>
                                <Box margin={1}>
                                    <Typography variant="h6" gutterBottom component="div">
                                        Meeting Rooms
                                    </Typography>
                                    <Table size="small" aria-label="Hotels">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Meeting Date</TableCell>
                                                <TableCell>Meeting Time</TableCell>
                                                <TableCell>Room Setup</TableCell>
                                                <TableCell>Coffee Break Menu</TableCell>
                                                <TableCell>Coffee Break Time</TableCell>
                                                <TableCell>Coffee Break Price</TableCell>
                                                <TableCell>Lunch/Dinner Menu</TableCell>
                                                <TableCell>Lunch/DinnerTime</TableCell>
                                                <TableCell>Lunch/DinnerPrice</TableCell>
                                                <TableCell>Meeting Room Name</TableCell>
                                                <TableCell>Meeting Room Capacity</TableCell>
                                                <TableCell>Meeting Package Price</TableCell>
                                                <TableCell>Equipments - Name(Items No.)(Item Price)</TableCell>
                                                <TableCell>Payment Policy</TableCell>
                                                <TableCell>Cancellation Policy</TableCell>
                                                <TableCell>Free Policy</TableCell>
                                                <TableCell>Attachment</TableCell>
                                                <TableCell>Notes</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {row.reservationSupplierHotelMeetingResources.map((RoomRow, index) => (
                                                <TableRow key={index}>
                                                    <TableCell component="th" scope="row" className={classes.wideTd}>
                                                        {RoomRow.meetingDate.substring(0, 10)}
                                                    </TableCell>
                                                    <TableCell>{RoomRow.meetingTime.substring(0, 5)}</TableCell>
                                                    <TableCell className={classes.wideTd}>{RoomRow.roomSetup}</TableCell>
                                                    <TableCell className={classes.wideTd}>{renderAttachment(RoomRow.coffeeBreakMenu)}</TableCell>
                                                    <TableCell>{RoomRow.coffeeBreakTime ? RoomRow.coffeeBreakTime : '-'}</TableCell>
                                                    <TableCell>{RoomRow.coffeeBreakPrice ? RoomRow.coffeeBreakPrice : '-'}</TableCell>
                                                    <TableCell className={classes.wideTd}>{renderAttachment(RoomRow.lunchOrDinnerMenu)}</TableCell>
                                                    <TableCell>{RoomRow.lunchOrDinnerTime ? RoomRow.lunchOrDinnerTime : '-'}</TableCell>
                                                    <TableCell>{RoomRow.lunchOrDinnerPrice ? RoomRow.lunchOrDinnerPrice : '-'}</TableCell>
                                                    <TableCell className={classes.wideTd}>{RoomRow.meetingRoomName}</TableCell>
                                                    <TableCell>{RoomRow.meetingRoomCapacity}</TableCell>
                                                    <TableCell>{RoomRow.meetingPackagePrice}</TableCell>
                                                    <TableCell className={classes.wideTd}>
                                                        {
                                                            RoomRow.reservationSupplierHotelMeetingEquipmentResources.map((equipment, index) => (
                                                                <div key={index}>
                                                                    {`${equipment.equipmentName} (${equipment.availableItems}) (${equipment.itemPrice})`}
                                                                </div>
                                                            ))
                                                        }
                                                    </TableCell>
                                                    <TableCell className={`${classes.wideTd} no-wrap`}>{RoomRow.paymentPolicy}</TableCell>
                                                    <TableCell className={`${classes.wideTd} no-wrap`}>{RoomRow.cancellationPolicy}</TableCell>
                                                    <TableCell className={`${classes.wideTd} no-wrap`}>{RoomRow.freePolicy}</TableCell>
                                                    <TableCell>{renderAttachment(RoomRow.attachment)}</TableCell>
                                                    <TableCell className={`${classes.wideTd} no-wrap`}>{RoomRow.notes}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </Box>
                            </Collapse>
                        </TableCell>
                    </TableRow>
                    : null
            }

        </React.Fragment>
    );
}


export default HotelAppliedOffers;